import Helper from '../riHelper';
import { ensureSPClientContext } from '../utils';
import getViewFieldsXml from '../central/getViewFieldsXml';
import Promise from 'bluebird';
import { TaxonomyHelper } from './TaxonomyHelper';
import { every } from '@/central';
import { ensureSod } from '@/central/utils';
var BaseService = (function () {
    function BaseService() {
        var _this = this;
        this.parseItem = function (item, categoryField, list, web, site) {
            var date = item.get_item(_this.fieldDate);
            var editDate = item.get_item(_this.fieldEditDate);
            var result = {
                id: item.get_id(),
                title: item.get_item(_this.fieldTitle),
                date: date ? date.toISOString() : undefined,
                editDate: editDate ? editDate.toISOString() : undefined,
                teaser: item.get_item(_this.fieldTeaser),
                url: item.get_item('FileRef'),
                majorVersion: Math.floor(parseFloat(item.get_item('_UIVersionString'))),
                public: item.get_item('_ModerationStatus') === 0
            };
            if (result.url.endsWith('.000')) {
                result.url = web.get_serverRelativeUrl().replace(/\/+$/, '') + "/_layouts/15/listform.aspx?PageType=4&ListId=" + list.get_id() + "&ID=" + result.id;
            }
            return _this.finalizeItem(result, item, categoryField, list, web, site);
        };
    }
    BaseService.prototype.loadItemsByQuery = function (viewChildren) {
        var _this = this;
        return ensureSPClientContext.then(function () {
            return ensureSod('sp.taxonomy.js', 'SP.Taxonomy.TaxonomySession', function () {
                SP.SOD.registerSod('sp.taxonomy.js', '/_layouts/15/sp.taxonomy.js?rev=gXJxm9XW5wXmexhrflC7sQ');
            }).then(function () {
                var webUrl = _spPageContextInfo.siteAbsoluteUrl + "/" + _this.urlWeb;
                var listUrl = webUrl + "/" + _this.urlList;
                var ctx = new SP.ClientContext(webUrl);
                var site = ctx.get_site();
                ctx.load(site, 'ServerRelativeUrl');
                var web = ctx.get_web();
                ctx.load(web, 'ServerRelativeUrl');
                var list = web.getList(listUrl);
                ctx.load(list, 'Id');
                var categoryGenericField = list.get_fields().getByInternalNameOrTitle(_this.fieldCategory);
                ctx.load(categoryGenericField);
                var viewFields = ['Author', '_UIVersionString', '_ModerationStatus', _this.fieldDate, _this.fieldEditDate, _this.fieldTitle, _this.fieldTeaser, 'FileRef', _this.fieldCategory];
                viewFields.push.apply(viewFields, _this.viewFields);
                var fields = getViewFieldsXml(viewFields);
                var query = new SP.CamlQuery();
                query.set_viewXml("<View>" + fields + viewChildren + "</View>");
                var items = list.getItems(query);
                ctx.load(items);
                return new Promise(function (resolve, reject) {
                    return Helper.clientContextExecute(ctx)
                        .then(function () {
                        var categoryField = ctx.castTo(categoryGenericField, SP.Taxonomy.TaxonomyField);
                        var result = [];
                        var ps = [];
                        if (items.get_areItemsAvailable()) {
                            every(items, function (item, i) {
                                var p = _this.parseItem(item, categoryField, list, web, site);
                                ps.push(p);
                                p.then(function (resultItem) {
                                    result[i] = resultItem;
                                });
                            });
                            Promise.all(ps).then(function () {
                                _this.finalizeItems(result, list, web, site).then(function (finalResult) {
                                    resolve(finalResult);
                                });
                            });
                        }
                        else {
                            resolve([]);
                        }
                    })
                        .catch(reject);
                });
            });
        });
    };
    BaseService.prototype.getOrderByCaml = function (sort) {
        var caml = "<FieldRef Name=\"" + this.fieldTitle + "\" Ascending=\"TRUE\"/>";
        var sortParts = (sort || '').split(' ');
        var field = sortParts[0];
        var asc = sortParts[1] === 'asc';
        if (sortParts.length >= 2) {
            caml = "<FieldRef Name=\"" + (field == 'date' ? this.fieldDate : this.fieldTitle) + "\" Ascending=\"" + (asc ? 'TRUE' : 'FALSE') + "\"/>";
        }
        return { caml: caml, field: field, asc: asc, special: sortParts[2] };
    };
    BaseService.prototype.loadItems = function (categoryGuid, sort, rowLimit) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            TaxonomyHelper.getWssIdByTermId(categoryGuid).then(function (categoryId) {
                return Helper.context()
                    .then(function () {
                    var orderBy = _this.getOrderByCaml(sort);
                    return _this.loadItemsByQuery("<Query><Where><Contains><FieldRef LookupId='True' Name='" + _this.fieldCategory + "'/><Value Type='Integer'>" + categoryId + "</Value></Contains></Where><OrderBy>" + orderBy.caml + "</OrderBy></Query><RowLimit>" + rowLimit + "</RowLimit>").then(function (items) {
                        resolve(items);
                    });
                })
                    .catch(reject);
            });
        });
    };
    BaseService.getDropPopItems = function (component) {
        if (component === void 0) { component = ''; }
        var dropPopItems = [
            {
                id: '10',
                label: 'alphabetisch (A-Z)',
                value: 'title asc',
                selected: true
            },
            {
                id: '20',
                label: 'alphabetisch (Z-A)',
                value: 'title desc'
            },
            {
                id: '30',
                label: 'Neuste zuerst',
                value: 'date desc'
            },
            {
                id: '40',
                label: 'Älteste zuerst',
                value: 'date asc'
            }
        ];
        if (component === 'eventNavi') {
            dropPopItems[0].selected = false;
            dropPopItems.splice(0, 0, {
                id: '1',
                label: 'chronologisch',
                value: 'date asc emptylast',
                selected: true
            });
        }
        return dropPopItems;
    };
    return BaseService;
}());
export { BaseService };
